import { Component, OnInit, input } from '@angular/core';
import { BandwidthPortInOrderNoteAndHistory } from '../../../../shared/models/generated/ziroModels';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';

@Component({
  selector: 'ziro-order-note',
  templateUrl: './order-note.component.html',
  styleUrls: ['./order-note.component.scss'],
  standalone: false,
})
export class OrderNoteComponent implements OnInit {
  readonly note = input<BandwidthPortInOrderNoteAndHistory>();
  readonly isLastNote = input<boolean>();
  readonly index = input<number>();

  ziroIcons = ZiroIcons;
  iconColor: string;

  ngOnInit(): void {
    this.iconColor = this._determineIconColor(this.note().userId);
  }

  private _determineIconColor(username: string): string {
    if (!username || username.length < 6) {
      return '#000';
    }
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += (username.charCodeAt(i) % 16).toString(16);
    }
    return color;
  }
}
